import { useQuery } from 'react-query'

import { globalSearchResultsQueryConfig } from '../../../query-configs'

export const useQueryGlobalSearchResults = (submittedQuery: string) => {
  const { data, isLoading, isError, error } = useQuery({
    ...globalSearchResultsQueryConfig.search(submittedQuery),
    enabled: submittedQuery !== '',
  })

  return { data, isLoading, isError, error }
}
